import React from 'react'

const BottomCard = () => {
  return (
    <div className=" w-full bg-[#f8fafc] p-4  md:p-8  min-h-[500px">
      <div className=" relative flex flex-col items-center my-20 bg-white px-6 py-10  md:p-[64px] rounded-[1rem] gap-4 text-center">
        {/* image */}
        <img
          src={
            'https://media.tradly.app/images/marketplace/95817/635b46228f935154d59621e8_emoji02-7TD1i4sb.webp'
          }
          alt="Default"
          className="absolute -top-[15%]  left-5 md:left-10 h-[100px] w-[100px]  md:h-[144px] md:w-[144px]"
        />
        {/* Main part */}
        <h2 className="h2 max-w-[464px] mx-auto ">
          The all-in-one platform to drive community-led growth
        </h2>
        <p className=" text-start text-lightGray text-[18px] font-medium  leading-[27px]">
          Streamline your customer experience and create powerful customer communities in minutes
        </p>
        <button className="btn btn_primary !rounded-full">Book a Demo</button>

        {/* image */}
        <img
          src={
            'https://media.tradly.app/images/marketplace/11172/635b46b66718fe1f25341f29_memoji-ZZJsGJLc.webp'
          }
          alt="Default"
          className="absolute  bottom-5 md:bottom-10 right-4  md:right-10 h-[80px] w-[80px]"
        />
      </div>
    </div>
  )
}

export default BottomCard
